/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Notes_Empty_HintInputs */

const en_mobile_notes_empty_hint = /** @type {(inputs: Mobile_Notes_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No notes yet. Add note creates a note for this audio.`)
};

const es_mobile_notes_empty_hint = /** @type {(inputs: Mobile_Notes_Empty_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay notas. Agregar nota crea una nota para este audio.`)
};

/**
* | output |
* | --- |
* | "No notes yet. Add note creates a note for this audio." |
*
* @param {Mobile_Notes_Empty_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_notes_empty_hint = /** @type {((inputs?: Mobile_Notes_Empty_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Notes_Empty_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_notes_empty_hint(inputs)
	return en_mobile_notes_empty_hint(inputs)
});